// import {whiteColor, oceanBlueColor,  DodgerBlueColor} from '../../cmsMainStyle'

const circulationRecipientFormStyle = theme => ({
	btnArea: {
		paddingTop: theme.spacing(2),
	}
})

export {circulationRecipientFormStyle}